module.exports = __webpack_public_path__ + "static/media/wildOz.a09454f0.png";